import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import EkulturLoginHandler from "./framework/EkulturLoginHandler/EkulturLoginHandler";
import RootView from "./views/RootView";
import Messenger from "./framework/Messenger/Messenger";
import Settings from "./Settings";
import { ModalManager } from "./framework/ModalManager";
import ErrorView from "@/views/ErrorView";
import "external-svg-loader";
import { APIProvider } from "@vis.gl/react-google-maps";
import { useFonts } from "@ekultur/react-fonts";
import { inter } from "@ekultur/fonts";
import TrackingInitHandler from "@/TrackingInitHandler";
import { AuthErrorProvider } from "./AuthErrorContext";

const router = createBrowserRouter([
  {
    path: "*",
    Component: Root,
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}

function Root() {
  Settings.validateSettings();
  useFonts(inter);
  return (
    <Messenger>
      <ErrorBoundary FallbackComponent={ErrorView}>
        <TrackingInitHandler />
        <EkulturLoginHandler>
          <AuthErrorProvider>
            <APIProvider apiKey={Settings.GOOGLE_MAPS_API_KEY}>
              <ModalManager />
              <RootView />
            </APIProvider>
          </AuthErrorProvider>
        </EkulturLoginHandler>
      </ErrorBoundary>
    </Messenger>
  );
}
